import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { axios } from "../../../../../Global";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import { BiDotsVerticalRounded, BiEdit, BiHide, BiShow } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import ContractCostSheetEdit from "../ContractCostSheetEdit";
import ContractFileUpload from "../ContractFileUpload";
import ContractAdvancedSecurityTable from "../ContractAdvancedSecurity";
import ProceedToProject from "../ProceedToProjectPopup";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import ContractViewFirstTable from "./ContractViewFirstTable";
import ContractClientDetailsTable from "./ContractClientDetailsTable";
import ContractCompanyDetailsTable from "./ContractCompanyDetailsTable";
import ContractFilesTable from "./ContractFilesTable";
import ContractCostSheetTable from "./ContractCostSheetTable";
import MoreDetails from "./MoreDetails";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import HourlyContract from "../contractPdf/HourlyContract/HourlyContract";
import CostPlusContract from "../contractPdf/CostPlusContract";
import MonthlyContract from "../contractPdf/MonthlyContract/MonthlyContract";
import ContractService from "../contractPdf/ContractService";
import GenerateContract from "./GenerateContract";
import GenerateServicePDFPopup from "./GenerateServicePDFPopup";
import GenerateHoulryContract from "./GenerateHoulryContract";
import GenerateCostPlusPDFPopup from "./GenerateCostPlusPDFPopup";

export default function ContractSingleView() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const costSheetEditing = location.pathname.includes("cost-sheet-edit");
  const [loading, setLoading] = useState(true);
  const { contractId } = useParams();
  const [contractDetails, setContractDetails] = useState({});
  const [updateComponent, setUpdateComponent] = useState(false);
  const { breadCrumbs } = useSelector((state) => state.user);
  const [openGenerateQuotation, setOpenGenerateQuotation] = useState(false);

  useEffect(
    function addBreadCrumb() {
      dispatch(
        setBreadCrumb([
          { label: `CONTRACT`, link: `/dashboard/contract` },
          {
            label: `${contractDetails?.contract?.contract_number || "VIEW"}`,
            link: `/dashboard/contract/${contractDetails?.contract?.id}`,
          },
        ])
      );
    },
    [location.pathname, contractDetails]
  );

  const [contractCostSheetState, setContractCostSheetState] = useState({
    open: false,
    costSheetId: "",
  });
  const [contractFileUploadState, setContractFileUploadState] = useState({
    open: false,
    contractId: contractId,
  });
  const [proceedToProjectState, setProceedToProjectState] = useState({
    open: false,
    projectType: "",
  });

  const proceedToProjectHandler = (contractId) => {
    setProceedToProjectState((p) => ({
      ...p,
      open: true,
    }));
  };
  const contractCostSheetModalHandler = (costSheetId) => {
    const currentCostSheet = contractDetails.contract_cost_sheet.find(
      (e) => e.id === costSheetId
    );
    setContractCostSheetState((p) => ({
      ...p,
      open: true,
      costSheetId: costSheetId,
      currentCostSheet: currentCostSheet,
    }));
  };

  useEffect(() => {
    console.log("hehe ", 93);
    axios
      .get(`/dashboard/contract/${contractId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.data) {
          setContractDetails(res.data.data);
          console.log("data ", res.data.data);
          setLoading(false);
        } else {
          throw new Error("Data not found.");
        }
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        navigate("/dashboard/contract");
        setLoading(false);
      });
  }, [updateComponent, proceedToProjectState]);

  const downloadFile = async (type) => {
    try {
      const response = await axios.get(
        `/dashboard/contract-file-download/${type}/${contractId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${type} PDF`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "PDF Downloaded",
            color: "success",
          })
        );
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const InitialSelectedTItles = [
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },

    {
      col: "HRA",
      title: "hra",
    },
    {
      col: "Total Monthly Per Head Cost",
      title: "total_monthly_cost_head",
    },
  ];
  const InitialSelectedTItlesHourly = [
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },
    {
      col: "HRA",
      title: "hra",
    },
    {
      col: "Total Monthly Per Head Cost",
      title: "total_monthly_cost_head",
    },
    {
      col: "Per Day Hours",
      title: "per_day_hour",
    },
  ];

  const [isThreeDotOpen, setIsThreeDotOpen] = useState(false);
  const [generatePDFState, setGeneratePDFState] = useState({
    open: false,
    component: null,
    contractDetails: contractDetails,
    filename: null,
  });

  const [costPlusPDFState, setCostPlusPDFState] = useState(false);

  return (
    <>
      {openGenerateQuotation &&
        contractDetails?.contract?.quotation_type?.name == "Monthly" && (
          <GenerateContract
            InitialSelectedTItles={InitialSelectedTItles}
            openGenerateQuotation={openGenerateQuotation}
            setOpenGenerateQuotation={setOpenGenerateQuotation}
            list={contractDetails}
            contractDetails={contractDetails}
          />
        )}
      {openGenerateQuotation &&
        contractDetails?.contract?.quotation_type?.name == "Hourly" && (
          <GenerateHoulryContract
            InitialSelectedTItles={InitialSelectedTItlesHourly}
            openGenerateQuotation={openGenerateQuotation}
            setOpenGenerateQuotation={setOpenGenerateQuotation}
            list={contractDetails}
            contractDetails={contractDetails}
          />
        )}

      {openGenerateQuotation &&
        contractDetails?.contract?.quotation_type?.name == "Cost Plus" && (
          <GenerateCostPlusPDFPopup
            openGenerateQuotation={openGenerateQuotation}
            setOpenGenerateQuotation={setOpenGenerateQuotation}
            list={contractDetails}
          />
        )}
      {proceedToProjectState.open && (
        <ProceedToProject
          showPromptElement={proceedToProjectState}
          setShowPromptElement={setProceedToProjectState}
          setProceedToProjectState={setProceedToProjectState}
          proceedToProjectHandler={proceedToProjectHandler}
          contractId={contractId}
        />
      )}
      {contractCostSheetState.open && (
        <ContractCostSheetEdit
          showPromptElement={contractCostSheetState}
          setShowPromptElement={setContractCostSheetState}
          updateComponent={setUpdateComponent}
        />
      )}
      {generatePDFState.open && (
        <GenerateServicePDFPopup
          state={generatePDFState}
          setState={setGeneratePDFState}
        />
      )}

      {!loading ? (
        <>
          {!costSheetEditing ? (
            <div className="md:p-5 p-2">
              <div className="flex flex-wrap justify-between items-center">
                <div>
                  <h1 className="font-semibold text-lg">Status Summary:</h1>
                  <h2 className="text-xs">
                    View details of the contract, get confirmation and then
                    proceed to project.
                  </h2>
                </div>
                <div className="flex  sm:justify-center justify-between sm:mt-0 mt-2 sm:w-fit w-full items-center gap-2">
                  <div className="min-w-fit relative">
                    {contractDetails?.project == null ? (
                      <button
                        onClick={() =>
                          setProceedToProjectState((p) => ({
                            ...p,
                            open: true,
                            projectType: "new",
                          }))
                        }
                        className="rounded-md bg-red p-2 min-w-fit text-sm text-white peer"
                      >
                        Create Project
                      </button>
                    ) : (
                      <Link
                        to={`/dashboard/project/${contractDetails?.project?.id}`}
                      >
                        <button className="rounded-md bg-red p-2 min-w-fit text-sm text-white">
                          View Project
                        </button>
                      </Link>
                    )}

                    {/* {(checkAccess("Project", "project-create") ||
                      checkAccess("Contract", "contract-edit")) && (
                      <div className="hidden  absolute  lg:right-0 right-auto lg:left-auto left-0  top-9 z-50 max-w-xs w-[17rem] h-auto bg-white shadow-md rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
                        {checkAccess("Project", "project-create") && (
                          <button
                            onClick={() =>
                              setProceedToProjectState((p) => ({
                                ...p,
                                open: true,
                                projectType: "new",
                              }))
                            }
                            className="w-full"
                          >
                            <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                              Create new Project
                            </p>
                          </button>
                        )}
                        {checkAccess("Contract", "contract-edit") && (
                          <button
                            onClick={() =>
                              setProceedToProjectState((p) => ({
                                ...p,
                                open: true,
                                contractId: "",
                                projectType: "old",
                              }))
                            }
                            className="w-full"
                          >
                            <p className="bg-white p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                              Add to existing Project
                            </p>
                          </button>
                        )}
                      </div>
                    )} */}
                  </div>

                  {checkAccess("Contract", "contract-list") && (
                    <div className="w-full relative">
                      <button
                        className="rounded-md bg-white p-2 text-sm text-black"
                        onClick={() =>
                          setIsThreeDotOpen((prevState) => !prevState)
                        }
                      >
                        <BiDotsVerticalRounded size={"1.4rem"} />
                      </button>
                      {isThreeDotOpen && (
                        <div
                          className=" absolute  lg:right-0 -right-16  top-10 max-w-xs w-[17rem] h-auto bg-white shadow-md rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black block"
                          onMouseLeave={() => setIsThreeDotOpen(false)}
                        >
                          <button
                            className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3"
                            onClick={() =>
                              setGeneratePDFState({
                                open: true,
                                filename: "Contract.pdf",
                                component: (
                                  <ContractService
                                    contractDetails={contractDetails}
                                  />
                                ),
                              })
                            }
                          >
                            Download Contract
                          </button>
                          <button
                            onClick={() => setOpenGenerateQuotation(true)}
                            className={
                              "bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3"
                            }
                          >
                            Download Annexure
                          </button>

                          {/* {contractDetails?.contract?.quotation_type?.name ===
                            "Hourly" && (
                            <button className="bg-white p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                              <PDFDownloadLink
                                document={
                                  <HourlyContract
                                    contractDetails={contractDetails}
                                  />
                                }
                                fileName="Hourly-Annexure.pdf"
                              >
                                {(obj) => {
                                  console.log(obj, "aj pdf hourly");
                                  return obj?.loading
                                    ? "Loading document..."
                                    : "Download Annexure";
                                }}
                              </PDFDownloadLink>
                            </button>
                          )}
                          {contractDetails?.contract?.quotation_type?.name ===
                            "Cost Plus" && (
                            <button className="bg-white p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                              <PDFDownloadLink
                                document={
                                  <CostPlusContract
                                    contractDetails={contractDetails}
                                  />
                                }
                                fileName="CostPlus-Annexure.pdf"
                              >
                                {(obj) => {
                                  console.log(obj, "aj pdf costplus");
                                  return obj?.loading
                                    ? "Loading document..."
                                    : "Download Annexure";
                                }}
                              </PDFDownloadLink>
                            </button>
                          )}
                          {contractDetails?.contract?.quotation_type?.name ===
                            "Monthly" && (
                            <button className="bg-white p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                              <PDFDownloadLink
                                document={
                                  <MonthlyContract
                                    contractDetails={contractDetails}
                                  />
                                }
                                fileName="Monthly-Annexure.pdf"
                              >
                                {(obj) => {
                                  console.log(obj, "aj pdf monthly");
                                  return obj?.loading
                                    ? "Loading document..."
                                    : "Download Annexure";
                                }}
                              </PDFDownloadLink>
                            </button>
                          )} */}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <ContractViewFirstTable
                contractDetails={contractDetails}
                contractId={contractId}
                updateComponent={setUpdateComponent}
                updateValue={updateComponent}
              />

              <h1 className="text-lg font-semibold mt-6 mb-3">More Details</h1>
              <MoreDetails
                contractDetails={contractDetails}
                updateComponent={setUpdateComponent}
                setContractFileUploadState={setContractFileUploadState}
                contractId={contractId}
              />
              {/* <div className="p-2">
            <ContractCompanyDetailsTable contractDetails={contractDetails} />
          </div> */}
              {/* <div className="p-2">
            <ContractClientDetailsTable contractDetails={contractDetails} />
          </div> */}
              {/* <div className="p-2">
            <ContractFilesTable
              contractDetails={contractDetails}
              updateComponent={setUpdateComponent}
              setContractFileUploadState={setContractFileUploadState}
            />
          </div> */}
              {/* <div className="p-2">
            <ContractAdvancedSecurityTable
              contractDetails={contractDetails}
              updateComponent={setUpdateComponent}
              contractId={contractId}
            />
          </div> */}

              {/* <div className="p-2">
            <ContractCostSheetTable
              contractDetails={contractDetails}
              contractCostSheetModalHandler={contractCostSheetModalHandler}
              updateComponent={setUpdateComponent}
            />
          </div> */}
            </div>
          ) : (
            <Outlet context={{ contractDetails }} />
          )}
        </>
      ) : (
        <div className="flex justify-center items-center gap-3 mt-5 w-full ">
          <p>Loading</p>
          <CgSpinner className="animate-spin" />
        </div>
      )}
    </>
  );
}
